import { render, staticRenderFns } from "./SmsTemplateAddEditModal.vue?vue&type=template&id=585628cf&"
import script from "./SmsTemplateAddEditModal.vue?vue&type=script&lang=js&"
export * from "./SmsTemplateAddEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports